import logo from '../../logo.svg';
import '../../styles/App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from '../../theme/pages';
import PortfolioPage from '../../theme/pages/portfolio';
import _404 from '../../theme/pages/_404';


function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/portfolio" element={<PortfolioPage />}></Route>
            <Route path="*" element={<_404 />}></Route>
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
